import { privateAxios } from 'services/api/privateAxios';

export const getDriverAccountInfo = () =>
  privateAxios({
    method: 'get',
    url: '/driver/accountinfo',
  });
